var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptoIconGeneric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.3,537.3c-16.2-28.1-30-57-42.5-86.3c-55,93.9-90.3,198-104.1,305.5c105.2,54.1,232,60.3,345.6,9.8 C484.2,705,415.9,628.6,363.3,537.3z M404.2,494.4c53.9,94.5,126.2,177.2,212.5,242.8C716.1,673.1,785,566.2,798,442.8 c-92.2,36.9-192.5,57.8-297.8,57.8C467.7,500.6,435.8,498.1,404.2,494.4z M316.6,357C207.7,356.4,99.8,377.8,0,419.7 c5.8,118.1,63.8,231.1,164.4,304.2c14.1-98.3,46.1-195.6,98.9-286.9C279.4,408.9,297.5,382.5,316.6,357z M395.8,306.4 c-53.9-94.5-126.2-177.3-212.5-242.8C83.9,127.7,15,234.5,2,358c92.2-36.9,192.5-57.8,297.8-57.8 C332.3,300.2,364.2,302.7,395.8,306.4z M436.7,263.6c16.2,28.1,30,57,42.5,86.2c55-93.9,90.3-198,104.1-305.5 c-105.2-54.1-232-60.3-345.6-9.8C315.8,95.8,384.1,172.3,436.7,263.6z M483.4,443.8c108.9,0.6,216.7-20.8,316.6-62.7 C794.2,263,736.2,150,635.8,76.9c-14.1,98.3-46.2,195.6-98.9,286.9C520.6,391.9,502.5,418.3,483.4,443.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoIconGeneric);
export default __webpack_public_path__ + "static/media/crypto_icon-generic.8626240d42af8a17ee84817ed06d6605.svg";
export { ForwardRef as ReactComponent };